import BaseService from './BaseService'
import AccountModel from '../models/AccountModel'
import CategoriesModel from '../models/CategoriesModel'
import SettingUnitModel from '../models/SettingUnitModel'
import ViewSettingUnitModel from '../models/ViewSettingUnitModel'
import SettingReasonRejectModel from '../models/SettingReasonRejectModel'
import ProductModel from '../models/ProductModel'
import ViewProductModel from '../models/ViewProductModel'
import SettingsModel from '../models/SettingsModel'
import UsersModel from '../models/UsersModel'
import ProductChangedLogModel from '../models/ProductChangedLogModel'
import FormFieldModel from '../models/FormFieldModel'
import FieldSampleModel from '../models/FieldSampleModel'
import FieldsModel from '../models/FieldsModel'
import OrganizationModel from '../models/OrganizationModel'
import ViewOrganizationModel from '../models/ViewOrganizationModel'
import RequestActivationModel from '../models/RequestActivationModel'
import ProductSerialNumberInfoModel from '../models/ProductSerialNumberInfoModel'
import ProductSerialNumberInfoLogChangedModel from '../models/ProductSerialNumberInfoLogChangedModel'
import RequestActivationProductSerialModel from '../models/RequestActivationProductSerialModel'
import RequestActivationChangeLogModel from '../models/RequestActivationChangeLogModel'
import ProductSerialNumberModel from '../models/ProductSerialNumberModel'
import ProductSerialNumberInfoStatusChangedModel from '../models/ProductSerialNumberInfoStatusChangedModel'
import ImportDataProcessingModel from '../models/ImportDataProcessingModel'
import ProductOrderModel from '../models/ProductOrderModel'
import ProductOrderListModel from '../models/ProductOrderListModel'
import ProductSerialNumberViewModel from '../models/ProductSerialNumberViewModel'
import WarrantyRepairHistoryModel from '../models/WarrantyRepairHistoryModel'
import ProductSerialNumberInfoLogChangedViewModel from '../models/ProductSerialNumberInfoLogChangedViewModel'
import RequestActivationLogChangeViewModel from '../models/RequestActivationLogChangeViewModel'
import RequestActivationExpandModel from '../models/RequestActivationExpandModel'
import RequestActivationProductSerialExpandModel from '../models/RequestActivationProductSerialExpandModel'
import MediaModel from '../models/MediaModel'
import CustomerModel from '../models/CustomerModel'
import ProvinceModel from '../models/ProvinceModel'
import ViewProvinceModel from '../models/ViewProvinceModel'
import DistrictModel from '../models/DistrictModel'
import ViewDistrictModel from '../models/ViewDistrictModel'
import WardModel from '../models/WardModel'
import ViewWardModel from '../models/ViewWardModel'
import ProductSerialNumberDynamicFormModel from '../models/ProductSerialNumberDynamicFormModel'
import CustomerLogChangeModel from '../models/CustomerLogChangeModel'
import GroupPermissionModel from '../models/GroupPermissionModel'
import UserLevelModel from '../models/UserLevelModel'
import ViewUserLevelModel from '../models/ViewUserLevelModel'
import RoleModel from '../models/RoleModel'
import ViewRoleModel from '../models/ViewRoleModel'
import RolePermissionModel from '../models/RolePermissionModel'
import OrganizationAccountModel from '../models/OrganizationAccountModel'
import UsersRoleModel from '../models/UsersRoleModel'
import TypeViolationModel from '../models/TypeViolationModel'
import ProductOrderDuplicateModel from '../models/ProductOrderDuplicateModel'
import ProductSerialNumberLogViewModel from '../models/ProductSerialNumberLogViewModel'
import AppraisalProductModel from '../models/AppraisalProductModel'
import AppraisalModel from '../models/AppraisalModel'
import AppraisalProductHistoryModel from '../models/AppraisalProductHistoryModel'
import RequestReturnProductModel from '../models/RequestReturnProductModel'
import RequestReturnProductProcessModel from '../models/RequestReturnProductProcessModel'
import AppraisalProductApprovalModel from '../models/AppraisalProductApprovalModel'
import ReportViolationModel from '../models/ReportViolationModel'
import ServiceSuppliesFormModel from '../models/ServiceSuppliesFormModel'
import ProductFromServicePackModel from '../models/ProductFromServicePackModel'
import ServiceSuppliesModel from '../models/ServiceSuppliesModel'
import ServiceParkModel from '../models/ServiceParkModel'
import ServiceUnitModel from '../models/ServiceUnitModel'
import ServicePackProduct from '../models/ServicePackProduct'
import ServicePackServiceSupplies from '../models/ServicePackServiceSupplies'
import UserTokenModel from '../models/UserTokenModel'
import WarrantyRepairModel from '../models/WarrantyRepairModel'
import WarrantyRepairDetailModel from '../models/WarrantyRepairDetailModel'
import WarrantyRepairTypeServiceModel from '../models/WarrantyRepairTypeServiceModel'
import ProductFromWarrantyRepairModel from '../models/ProductFromWarrantyRepairModel'
import WarrantyRepairProductSerialNumberModel from '../models/WarrantyRepairProductSerialNumberModel'
import TypeFailureCauseModel from '../models/TypeFailureCauseModel'
import WarrantyRepairProductSnHasServiceSuppliesModel from '../models/WarrantyRepairProductSnHasServiceSuppliesModel'
import WarrantyRepairProductSnHasServiceParkModel from '../models/WarrantyRepairProductSnHasServiceParkModel'
import WarrantyRepairProductSnHistoryUpdateModel from '../models/WarrantyRepairProductSnHistoryUpdateModel'
import ServicePackFromProductModel from '../models/ServicePackFromProductModel'
import ProductMaintenanceModel from '../models/ProductMaintenanceModel'
import WarrantyRepairProcessModel from '../models/WarrantyRepairProcessModel'
import MaintenanceModel from '../models/MaintenanceModel'
import MaintenanceProcessModel from '../models/MaintenanceProcessModel'
import ProductExistWarrantyRepairModel from '../models/ProductExistWarrantyRepairModel'
import MaintenanceSerialModel from '../models/MaintenanceSerialModel'
import ListHistoryUpdateRepairSerialModel from '../models/ListHistoryUpdateRepairSerialModel'
import RoleAccessModel from '../models/RoleAccessModel'
import HistoryExportModel from '../models/HistoryExportModel'
import ReportRequestActivationProductSerialModel from '../models/ReportRequestActivationProductSerialModel'
import ReportAppraisalProductModel from '../models/ReportAppraisalProductModel'
import ReportServiceSuppliesModel from '../models/ReportServiceSuppliesModel'
import ReportWarrantyRepairModel from '../models/ReportWarrantyRepairModel'

export default {
  services: {
    'accounts': {
      'model': new AccountModel(),
      'service': new BaseService(new AccountModel())
    },
    'categories': {
      'model': new CategoriesModel(),
      'service': new BaseService(new CategoriesModel())
    },
    'setting_unit': {
      'model': new SettingUnitModel(),
      'service': new BaseService(new SettingUnitModel())
    },
    'view_setting_unit': {
      'model': new ViewSettingUnitModel(),
      'service': new BaseService(new ViewSettingUnitModel())
    },
    'setting_reason_reject': {
      'model': new SettingReasonRejectModel(),
      'service': new BaseService(new SettingReasonRejectModel())
    },
    'product': {
      'model': new ProductModel(),
      'service': new BaseService(new ProductModel())
    },
    'view_product': {
      'model': new ViewProductModel(),
      'service': new BaseService(new ViewProductModel())
    },
    'settings': {
      'model': new SettingsModel(),
      'service': new BaseService(new SettingsModel())
    },
    'users': {
      'model': new UsersModel(),
      'service': new BaseService(new UsersModel())
    },
    'product_changed_log': {
      'model': new ProductChangedLogModel(),
      'service': new BaseService(new ProductChangedLogModel())
    },
    'form_field': {
      'model': new FormFieldModel(),
      'service': new BaseService(new FormFieldModel())
    },
    'field_sample': {
      'model': new FieldSampleModel(),
      'service': new BaseService(new FieldSampleModel())
    },
    'fields': {
      'model': new FieldsModel(),
      'service': new BaseService(new FieldsModel())
    },
    'organization': {
      'model': new OrganizationModel(),
      'service': new BaseService(new OrganizationModel())
    },
    'view_organization': {
      'model': new ViewOrganizationModel(),
      'service': new BaseService(new ViewOrganizationModel())
    },
    'request_activation': {
      'model': new RequestActivationModel(),
      'service': new BaseService(new RequestActivationModel())
    },
    'product_serial_number_info': {
      'model': new ProductSerialNumberInfoModel(),
      'service': new BaseService(new ProductSerialNumberInfoModel())
    },
    'product_serial_number_info_log_changed': {
      'model': new ProductSerialNumberInfoLogChangedModel(),
      'service': new BaseService(new ProductSerialNumberInfoLogChangedModel())
    },
    'request_activation_product_serial': {
      'model': new RequestActivationProductSerialModel(),
      'service': new BaseService(new RequestActivationProductSerialModel())
    },
    'request_activation_changed_log': {
      'model': new RequestActivationChangeLogModel(),
      'service': new BaseService(new RequestActivationChangeLogModel())
    },
    'product_serial_number': {
      'model': new ProductSerialNumberModel(),
      'service': new BaseService(new ProductSerialNumberModel())
    },
    'product_serial_number_info_status_changed': {
      'model': new ProductSerialNumberInfoStatusChangedModel(),
      'service': new BaseService(new ProductSerialNumberInfoStatusChangedModel())
    },
    'import_data_processing': {
      'model': new ImportDataProcessingModel(),
      'service': new BaseService(new ImportDataProcessingModel())
    },
    'production_order': {
      'model': new ProductOrderModel(),
      'service': new BaseService(new ProductOrderModel())
    },
    'production_order_list': {
      'model': new ProductOrderListModel(),
      'service': new BaseService(new ProductOrderListModel())
    },
    'product_serial_number_view': {
      'model': new ProductSerialNumberViewModel(),
      'service': new BaseService(new ProductSerialNumberViewModel())
    },
    'warranty_repair_history': {
      'model': new WarrantyRepairHistoryModel(),
      'service': new BaseService(new WarrantyRepairHistoryModel())
    },
    'product_serial_number_info_log_changed_view': {
      'model': new ProductSerialNumberInfoLogChangedViewModel(),
      'service': new BaseService(new ProductSerialNumberInfoLogChangedViewModel())
    },
    'view_request_activation_history_detail': {
      'model': new RequestActivationLogChangeViewModel(),
      'service': new BaseService(new RequestActivationLogChangeViewModel())
    },
    'request_activation_expand': {
      'model': new RequestActivationExpandModel(),
      'service': new BaseService(new RequestActivationExpandModel())
    },
    'request_activation_product_serial_expand': {
      'model': new RequestActivationProductSerialExpandModel(),
      'service': new BaseService(new RequestActivationProductSerialExpandModel())
    },
    'media': {
      'model': new MediaModel(),
      'service': new BaseService(new MediaModel())
    },
    'customer': {
      'model': new CustomerModel(),
      'service': new BaseService(new CustomerModel())
    },
    'provinces': {
      'model': new ProvinceModel(),
      'service': new BaseService(new ProvinceModel())
    },
    'view_province': {
      'model': new ViewProvinceModel(),
      'service': new BaseService(new ViewProvinceModel())
    },
    'districts': {
      'model': new DistrictModel(),
      'service': new BaseService(new DistrictModel())
    },
    'view_district': {
      'model': new ViewDistrictModel(),
      'service': new BaseService(new ViewDistrictModel())
    },
    'wards': {
      'model': new WardModel(),
      'service': new BaseService(new WardModel())
    },
    'view_ward': {
      'model': new ViewWardModel(),
      'service': new BaseService(new ViewWardModel())
    },
    'product_serial_number_dynamic_form': {
      'model': new ProductSerialNumberDynamicFormModel(),
      'service': new BaseService(new ProductSerialNumberDynamicFormModel())
    },
    'customer_log_changed': {
      'model': new CustomerLogChangeModel(),
      'service': new BaseService(new CustomerLogChangeModel())
    },
    'group_permission': {
      'model': new GroupPermissionModel(),
      'service': new BaseService(new GroupPermissionModel())
    },
    'user_level': {
      'model': new UserLevelModel(),
      'service': new BaseService(new UserLevelModel())
    },
    'view_user_level': {
      'model': new ViewUserLevelModel(),
      'service': new BaseService(new ViewUserLevelModel())
    },
    'roles': {
      'model': new RoleModel(),
      'service': new BaseService(new RoleModel())
    },
    'view_role': {
      'model': new ViewRoleModel(),
      'service': new BaseService(new ViewRoleModel())
    },
    'role_permission': {
      'model': new RolePermissionModel(),
      'service': new BaseService(new RolePermissionModel())
    },
    'organization_account': {
      'model': new OrganizationAccountModel(),
      'service': new BaseService(new OrganizationAccountModel())
    },

    'user_role': {
      'model': new UsersRoleModel(),
      'service': new BaseService(new UsersRoleModel())
    },
    'type_violation': {
      'model': new TypeViolationModel(),
      'service': new BaseService(new TypeViolationModel())
    },
    'production_order_duplicate': {
      'model': new ProductOrderDuplicateModel(),
      'service': new BaseService(new ProductOrderDuplicateModel())
    },
    'view_product_serial_number_info_history_detail': {
      'model': new ProductSerialNumberLogViewModel(),
      'service': new BaseService(new ProductSerialNumberLogViewModel())
    },
    'appraisal': {
      'model': new AppraisalModel(),
      'service': new BaseService(new AppraisalModel())
    },
    'appraisal_product': {
      'model': new AppraisalProductModel(),
      'service': new BaseService(new AppraisalProductModel())
    },
    
    'appraisal_product_history': {
      'model': new AppraisalProductHistoryModel(),
      'service': new BaseService(new AppraisalProductHistoryModel())
    },

    'request_return_product': {
      'model': new RequestReturnProductModel(),
      'service': new BaseService(new RequestReturnProductModel())
    },

    'request_return_product_process': {
      'model': new RequestReturnProductProcessModel(),
      'service': new BaseService(new RequestReturnProductProcessModel())
    },
    
    'appraisal_product_approval': {
      'model': new AppraisalProductApprovalModel(),
      'service': new BaseService(new AppraisalProductApprovalModel())
    },
    
    'report_violation': {
      'model': new ReportViolationModel(),
      'service': new BaseService(new ReportViolationModel())
    },
    'service_supplies': {
      'model': new ServiceSuppliesModel(),
      'service': new BaseService(new ServiceSuppliesModel())
    },
    'service_supplies_form': {
      'model': new ServiceSuppliesFormModel(),
      'service': new BaseService(new ServiceSuppliesFormModel())
    },
    'product_from_service_pack': {
      'model': new ProductFromServicePackModel(),
      'service': new BaseService(new ProductFromServicePackModel())
    },
    'service_pack_product': {
      'model': new ServicePackProduct(),
      'service': new BaseService(new ServicePackProduct())
    },
    'service_pack_service_supplies': {
      'model': new ServicePackServiceSupplies(),
      'service': new BaseService(new ServicePackServiceSupplies())
    },
    'service_park': {
      'model': new ServiceParkModel(),
      'service': new BaseService(new ServiceParkModel())
    },
    'service_unit': {
      'model': new ServiceUnitModel(),
      'service': new BaseService(new ServiceUnitModel())
    },
    'user_token': {
      'model': new UserTokenModel(),
      'service': new BaseService(new UserTokenModel())
    },
    'warranty_repair': {
      'model': new WarrantyRepairModel(),
      'service': new BaseService(new WarrantyRepairModel())
    },
    'warranty_repair_detail': {
      'model': new WarrantyRepairDetailModel(),
      'service': new BaseService(new WarrantyRepairDetailModel())
    },
    'warranty_repair_type_service': {
      'model': new WarrantyRepairTypeServiceModel(),
      'service': new BaseService(new WarrantyRepairTypeServiceModel())
    },
    'product_from_warranty_repair': {
      'model': new ProductFromWarrantyRepairModel(),
      'service': new BaseService(new ProductFromWarrantyRepairModel())
    },
    'warranty_repair_product_serial_number': {
      'model': new WarrantyRepairProductSerialNumberModel(),
      'service': new BaseService(new WarrantyRepairProductSerialNumberModel())
    },
    'type_failure_cause': {
      'model': new TypeFailureCauseModel(),
      'service': new BaseService(new TypeFailureCauseModel())
    },
    'warranty_repair_product_sn_has_service_park': {
      'model': new WarrantyRepairProductSnHasServiceParkModel(),
      'service': new BaseService(new WarrantyRepairProductSnHasServiceParkModel())
    },
    'warranty_repair_product_sn_has_service_supplies': {
      'model': new WarrantyRepairProductSnHasServiceSuppliesModel(),
      'service': new BaseService(new WarrantyRepairProductSnHasServiceSuppliesModel())
    },
    'warranty_repair_product_sn_history_update': {
      'model': new WarrantyRepairProductSnHistoryUpdateModel(),
      'service': new BaseService(new WarrantyRepairProductSnHistoryUpdateModel())
    },
    'service_pack_from_product': {
      'model': new ServicePackFromProductModel(),
      'service': new BaseService(new ServicePackFromProductModel())
    },
    'product_maintenance': {
      'model': new ProductMaintenanceModel(),
      'service': new BaseService(new ProductMaintenanceModel())
    },
    'warranty_repair_process': {
      'model': new WarrantyRepairProcessModel(),
      'service': new BaseService(new WarrantyRepairProcessModel())
    },
    'maintenance': {
      'model': new MaintenanceModel(),
      'service': new BaseService(new MaintenanceModel())
    },
    'maintenance_process': {
      'model': new MaintenanceProcessModel(),
      'service': new BaseService(new MaintenanceProcessModel())
    },
    'product_exist_warranty_repair': {
      'model': new ProductExistWarrantyRepairModel(),
      'service': new BaseService(new ProductExistWarrantyRepairModel())
    },
    'maintenance_serial': {
      'model': new MaintenanceSerialModel(),
      'service': new BaseService(new MaintenanceSerialModel())
    },
    'list_history_update_repair_serial': {
      'model': new ListHistoryUpdateRepairSerialModel(),
      'service': new BaseService(new ListHistoryUpdateRepairSerialModel())
    },
    'role_access': {
      'model': new RoleAccessModel(),
      'service': new BaseService(new RoleAccessModel())
    },
    'history_export': {
      'model': new HistoryExportModel(),
      'service': new BaseService(new HistoryExportModel())
    },
    'report_request_activation_product_serial': {
      'model': new ReportRequestActivationProductSerialModel(),
      'service': new BaseService(new ReportRequestActivationProductSerialModel())
    },
    'report_appraisal_product': {
      'model': new ReportAppraisalProductModel(),
      'service': new BaseService(new ReportAppraisalProductModel())
    },
    'report_service_supplies': {
      'model': new ReportServiceSuppliesModel(),
      'service': new BaseService(new ReportServiceSuppliesModel())
    },
    'report_warranty_repair': {
      'model': new ReportWarrantyRepairModel(),
      'service': new BaseService(new ReportWarrantyRepairModel())
    },

  },
  getModel(modelName) {
    return this.services[modelName].model
  },
  countData(modelName, params) {
    return this.services[modelName].service.countDataQuery(params);
  },
  getList(modelName, params) {
    return this.services[modelName].service.getListQuery(params);
  },
  async getObjectData(table,where,order_by =null) {
    var variables = {
      where_key: where,
      limit: 1
    }
    if (order_by){
      variables.orderBy = order_by;
    }
    var data = await this.getList(table, {"variables": JSON.stringify(variables)})
    var list = data[Object.keys(data)];
    if (list !== undefined && list !== null && Object.keys(list).length) {
      var item = list[0];
      if (item){
        return item;
      }
    }
    return null;
  },
  async getListData(modelName,params) {
    var data = await this.getList(modelName, params)
    var list = data[Object.keys(data)];
    if (list !== undefined && list !== null && Object.keys(list).length) {
      return list;
    }
    return [];
  },
  countList(modelName, params) {
    return this.services[modelName].service.countListQuery(params);
  },
  updateData(modelName, params) {
      return this.services[modelName].service.updateDataQuery(params);
  },
  insertData(modelName, params) {
    return this.services[modelName].service.insertDataQuery(params);
  },
  deleteData(modelName, params) {
    return this.services[modelName].service.deleteDataQuery(params);
  },
  executeQuery(modelName,queries, params) {
    //modelName gán vào để vào gọi call được function callExecute
    return this.services[modelName].service.callExecute(queries, params);
  }
};
